import { IconBase } from './iconBase';

import { CustomIconsProp } from '../types';

export const JobDetails = ({ size, className }: CustomIconsProp) => (
  <IconBase className={className} viewBox={24} size={size}>
    <rect
      x={2}
      y={7}
      width={20}
      height={14}
      rx={2}
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
    />
    <path
      d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
    />
  </IconBase>
);
